export const STEPS = {
  HOME: 'HOME',
  LOADING: 'LOADING',
  VIDEO_UPLOAD: 'VIDEO_UPLOAD',
  PHOTO_UPLOAD: 'PHOTO_UPLOAD',
  UPLOADING: 'UPLOADING',
  TARGET_UPLOAD_SUCCESS: 'TARGET_UPLOAD_SUCCESS',
};
